var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { Loading } from 'element-ui';
import { mapGetters, mapActions } from 'vuex';
import { Component } from 'vue-property-decorator';
import Pagination from "../../common/components/Pagination";
import GoodService from "../../api/GoodService";
import LicenseService from '../../api/LicenseService';
import GlobalVue from "../../globalVue";
import { UrlHelper } from '../../helper/UrlWrapper';
import ArticleList from "../../components/alert/ArticleList.vue";
import CategoryDialog from './components/CategoryDialog.vue';
import GoodDetail from "./GoodDetail.vue";
import AddGood from "./AddGood.vue";
import GoodCategory from '../goodcategory/GoodCategory.vue';
import transferDialog from './TransferDialog.vue';
import SetDefaultSupplierDialog from './SetDefaultSupplierDialog.vue';
import SeeBindLicenses from './SeeBindLicenses';
import AddLicenses from './components/addLicensesCol2/AddLicenses';
import ArtMsglist from "../../components/alert/ArtMsglist.vue";
import CommonService from "../../api/CommonService";
import ShoppingManageService from '../../api/ShoppingManageService';
var List = (function (_super) {
    __extends(List, _super);
    function List() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {
            shopping_status: -1,
            saleStatus: -1
        };
        _this.importFormData = {
            type: 1
        };
        _this.total = 0;
        _this.tableHeight = 500;
        _this.categoryData = [];
        _this.goodList = [];
        _this.goodStatus = [];
        _this.statusList = [
            { id: -1, name: '全部' },
            { id: 0, name: '未上架' },
            { id: 1, name: '已上架' }
        ];
        _this.selectRows = [];
        _this.dialogTableVisible = false;
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.dialogImageVisible = false;
        _this.failDownLoadUrl = "";
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = "";
        _this.successMsg = "";
        _this.uploadType = 'file';
        _this.imageBeforeImport = true;
        _this.imageImporting = false;
        _this.imageAfterImport = false;
        _this.imageFailDownLoadUrl = "";
        _this.imageResponseSuccess = false;
        _this.imageResponseFail = false;
        _this.imageImportSuccessNum = 0;
        _this.imageImportFailNum = 0;
        _this.imageImportFailData = [];
        _this.isEdit = false;
        _this.activeRow = {};
        _this.is_open_shop = false;
        return _this;
    }
    List.prototype.saveEditRow = function () {
        var _this = this;
        if (!this.isEdit || !this.activeRow.goods_id) {
            return;
        }
        var params = {
            goods_id: this.activeRow.goods_id,
            sort: this.activeRow.sort
        };
        this.service.updateGoodsSort(params).catch(function (e) {
            _this.$message.error(e.msg || e.message || '修改失败');
        }).finally(function () {
            _this.isEdit = false;
            _this.activeRow = {};
        });
    };
    List.prototype.editRowSort = function (row) {
        this.activeRow = row;
        this.isEdit = true;
    };
    List.prototype.created = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.$el && _this.$el.parentElement) {
                _this.tableHeight = _this.$el.parentElement.clientHeight - 130;
            }
        }, 300);
        this.service = GoodService.getInstance();
        this.commonService = CommonService.getInstance();
        this.licenseService = LicenseService.getInstance();
        this.shoppingService = ShoppingManageService.getInstance();
        this.getShopDetail();
        this.getAuth('8002').then(function (pageAuth) {
            if (pageAuth) {
                _this.pafeAuthInfo = pageAuth;
            }
        });
    };
    List.prototype.mounted = function () {
        this.is_apply_auth = this.$store.state.config.is_apply_auth;
        this.getGoodList();
        this.getCategory();
    };
    List.prototype.getShopDetail = function () {
        var _this = this;
        this.getAuth("310001").then(function (pageAuth) {
            if (pageAuth) {
                _this.shoppingService.configShow({}).then(function (res) {
                    _this.is_open_shop = res.data.data.is_open_shop;
                });
            }
        });
    };
    List.prototype.getGoodList = function (pager) {
        var _this = this;
        pager = pager ? pager : this.$refs.pagination.getPage();
        var params = this.getParams();
        Object.assign(params, pager);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getGoodList(params).then(function (res) {
            if (res.data.success) {
                _this.goodList = res.data.data;
                _this.total = res.data.count;
            }
            else {
                _this.$message.error(res.data.msg);
            }
            loadingInstance.close();
        }, function (err) {
            _this.$message.error(err.message || err.msg);
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    List.prototype.getCategory = function () {
        var _this = this;
        this.service.getCategory().then(function (res) {
            if (res.data.success) {
                _this.categoryData = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    List.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    List.prototype.addGood = function () {
        var _this = this;
        this.service.getCheck().then(function (res) {
            if (res.data.success && res.data.msg == 'success') {
                GlobalVue.$emit("addTab", {
                    component: AddGood,
                    opener: _this,
                    title: "新增货品",
                    name: "addgood",
                    showExist: true
                });
            }
            else {
                _this.$confirm("您还未上传货品类别，请先上传货品类别。", '提示', {
                    customClass: 'confirm',
                    confirmButtonText: '去添加',
                }).then(function (res) {
                    GlobalVue.$emit("addTab", {
                        component: GoodCategory,
                        opener: _this,
                        title: "货品类别",
                        name: "addgood",
                        showExist: true,
                        cprops: {
                            Root_PageAuth: _this.pafeAuthInfo && _this.pafeAuthInfo.Auth,
                            root_PageAuth$$: _this.pafeAuthInfo && _this.pafeAuthInfo.Auth
                        }
                    });
                }).catch(function (err) {
                    console.log(err);
                });
            }
        });
    };
    List.prototype.delGood = function (id) {
        var _this = this;
        this.$confirm('请确认是否删除该货品？', '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                var params_1 = {
                    goods_id: id
                };
                _this.service.delGood(params_1).then(function (res) {
                    _this.codeDeal(params_1, res);
                }, function (err) {
                    _this.$message.error(err.message || "删除失败");
                });
            }
        }).catch(function (err) {
            console.log(err);
        });
    };
    List.prototype.codeDeal = function (params, res) {
        var _this = this;
        if (res.data.code == 0) {
            this.getGoodList(this.$refs.pagination.pager);
            this.$message.success(res.data.msg || "删除成功");
            window._czc.push(["_trackEvent", '货品列表', '删除货品']);
            return;
        }
        ;
        if (res.data.code == 10 || res.data.code == 12) {
            var instance_1 = this.$dialog(ArticleList, {
                data: {
                    resData: res.data,
                    modelType: 'good',
                    sureButtonText: "确定",
                    showCancelButton: res.data.code == 12
                }
            }, {
                title: "提示",
                width: 450,
                height: 350,
                closeBtn: false,
            }).instance;
            instance_1.$on("addClient:ok", function (data) {
                var orderIdsStr = (res.data.data.data || []).join('、');
                var confirmStr = res.data.data.confirm;
                var delParams = Object.assign({}, params, {
                    confirm: confirmStr
                });
                _this.service.delGood(delParams).then(function (result) {
                    _this.codeDeal(params, result);
                });
            });
            return;
        }
        var instance = this.$dialog(ArticleList, {
            data: {
                resData: res.data,
                modelType: 'good',
                sureButtonText: "知道了"
            }
        }, {
            title: "提示",
            width: 450,
            height: 350,
            closeBtn: false,
        }).instance;
    };
    List.prototype.edit = function (row) {
        GlobalVue.$emit("addTab", {
            component: AddGood,
            opener: this,
            title: "编辑货品",
            name: "editgood-" + row.goods_id,
            showExist: true,
            cprops: {
                goodId: row.goods_id
            }
        });
    };
    List.prototype.importGoods = function () {
        var _this = this;
        this.service.getCheck().then(function (res) {
            if (res.data.success && res.data.msg == 'success') {
                _this.dialogTableVisible = true;
                _this.setUploadType("beford");
            }
            else {
                _this.$confirm("您还未上传货品类别，请先上传货品类别。", '提示', {
                    customClass: 'confirm',
                    confirmButtonText: '去添加',
                }).then(function (res) {
                    GlobalVue.$emit("addTab", {
                        component: GoodCategory,
                        opener: _this,
                        title: "货品类别",
                        name: "addgood",
                        showExist: true,
                        cprops: {
                            Root_PageAuth: _this.pafeAuthInfo && _this.pafeAuthInfo.Auth,
                            root_PageAuth$$: _this.pafeAuthInfo && _this.pafeAuthInfo.Auth
                        }
                    });
                }).catch(function (err) {
                    console.log(err);
                });
            }
        });
    };
    List.prototype.getParams = function () {
        var params = {
            shopping_status: this.formData.shopping_status,
            goods_type_id: this.formData.category,
            keyword: this.formData.text,
            sort_field: this.order ? this.order[0] : undefined,
            sort_type: this.order ? this.order[1] : undefined
        };
        var sortFieldMap = {
            'is_upto_mall_text': 'is_upto_mall',
            'shopping_status_text': 'shopping_status'
        };
        params.sort_field = sortFieldMap[params.sort_field] || params.sort_field;
        return params;
    };
    List.prototype.exportGoods = function (exportType) {
        var _this = this;
        var params = this.getParams();
        var orderIds = this.selectRows.map(function (item) { return item.goods_id; });
        var url = "supplierclientapi/suppliergoods/export_goods?in_goods_ids=" + orderIds.join(",") + "&export_type=" + exportType;
        url = UrlHelper.addParam(url, 'token', this.user.token);
        for (var key in params) {
            params[key] = (params[key] === undefined || params[key] === null) ? '' : params[key];
            url = UrlHelper.addParam(url, key, params[key]);
        }
        this.commonService.exportCheck(url)
            .then(function (res) {
            location.href = url;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
        window._czc.push(["_trackEvent", '货品列表', '导出货品']);
    };
    List.prototype.exportData = function () {
        var _this = this;
        var params = this.getParams();
        var url = "supplierclientapi/suppliergoods/export_goods?";
        url = UrlHelper.addParam(url, 'token', this.user.token);
        for (var key in params) {
            params[key] = (params[key] === undefined || params[key] === null) ? '' : params[key];
            url = UrlHelper.addParam(url, key, params[key]);
        }
        this.commonService.exportCheck(url)
            .then(function (res) {
            location.href = url;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
        window._czc.push(["_trackEvent", '货品列表', '导出结果']);
    };
    List.prototype.transferGood = function () {
        var _this = this;
        if (!this.selectRows.length) {
            this.$message.error('请先选择货品！');
            return;
        }
        var instance = this.$dialog(transferDialog, {
            data: {
                goodId: this.selectRows.map(function (item) { return item.goods_id; }).join(','),
                category: this.selectRows.length > 1 ? null : this.selectRows[0].goods_type_id
            }
        }, {
            title: "转移货品",
            width: 450,
            height: 200
        }).instance;
        instance.$on("transferCategory", function () {
            window._czc.push(["_trackEvent", '货品列表', '转移货品']);
            _this.getGoodList(_this.$refs.pagination.pager);
        });
    };
    List.prototype.setDefaultSupplier = function () {
        var _this = this;
        if (!this.selectRows.length) {
            this.$message.error('请先选择货品！');
            return;
        }
        var instance = this.$dialog(SetDefaultSupplierDialog, {
            data: {
                goodId: this.selectRows.map(function (item) { return item.goods_id; }).join(','),
                supplier_upper_id: this.selectRows.length > 1 ? null : (this.selectRows[0].supplier_upper_id || ''),
                selectRows: JSON.parse(JSON.stringify(this.selectRows))
            }
        }, {
            title: "设置默认供应商",
            width: 450,
            height: 200
        }).instance;
        instance.$on("setDefaultSupplier", function () {
            window._czc.push(["_trackEvent", '货品列表', '设置默认供应商']);
            _this.getGoodList(_this.$refs.pagination.pager);
        });
    };
    List.prototype.grounding = function (row) {
        var _this = this;
        var title = row.is_upto_mall_value == 1 ? '下架后，货品信息外部不可见。请确认是否下架？'
            : '上架后，货品信息将对外公开。请确认是否提交上架申请？';
        this.$confirm(title, '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                var params = {
                    goods_id: row.goods_id,
                    is_upto_mall: row.is_upto_mall_value == 1 ? 0 : 1
                };
                _this.service.downupGood(params).then(function (res) {
                    if (res.data.success) {
                        _this.getGoodList(_this.$refs.pagination.pager);
                        _this.$message.success(res.data.msg || "操作成功");
                    }
                    else {
                        _this.$message.error(res.data.msg || "操作失败");
                    }
                }, function (err) {
                    _this.$message.error(err.msg || "操作失败");
                });
            }
            window._czc.push(["_trackEvent", '货品列表', row.is_upto_mall_value == 1 ? '下架货品' : '上架货品', '确认']);
        }).catch(function () {
            window._czc.push(["_trackEvent", '货品列表', row.is_upto_mall_value == 1 ? '下架货品' : '上架货品', '取消']);
        });
    };
    List.prototype.multiGrunding = function (isup) {
        var _this = this;
        if (!this.selectRows.length) {
            this.$message.error('请先选择货品！');
            return;
        }
        console.log('multiGrunding>>>', isup, this.selectRows);
        if (isup === 1 && this.selectRows.every(function (v) { return v.shopping_status === 1; })) {
            return this.$message.warning('所选货品已上架商城');
        }
        if (isup === 0 && this.selectRows.every(function (v) { return v.shopping_status === 0; })) {
            return this.$message.warning('所选货品暂未上架商城');
        }
        var goods_ids = this.selectRows.map(function (v) { return v.goods_id; });
        var params = {
            goods_id: String(goods_ids),
            is_upto_mall: isup
        };
        var title = isup == 0 ? '下架后，货品信息外部不可见。请确认是否下架？'
            : '上架后，货品信息将对外公开。请确认是否提交上架申请？';
        this.$confirm(title, '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                _this.service.toggleMallGoodsStatus(params).then(function (res) {
                    if (res.data.success) {
                        _this.getGoodList(_this.$refs.pagination.pager);
                        _this.$message.success(res.data.msg || "操作成功");
                    }
                    else {
                        _this.$message.error(res.data.msg || "操作失败");
                    }
                }, function (err) {
                    _this.$message.error(err.message || err.msg || "操作失败");
                });
            }
            window._czc.push(["_trackEvent", '货品列表', isup == 1 ? '下架货品' : '上架货品', '确认']);
        }).catch(function () {
            window._czc.push(["_trackEvent", '货品列表', isup == 1 ? '下架货品' : '上架货品', '取消']);
        });
    };
    List.prototype.groundingMall = function (row) {
        var _this = this;
        var title = row.shopping_status == 1 ? '下架后，货品信息外部不可见。请确认是否下架？'
            : '上架后，货品信息将对外公开。请确认是否提交上架申请？';
        this.$confirm(title, '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                var params = {
                    goods_id: row.goods_id,
                    is_upto_mall: row.shopping_status == 1 ? 0 : 1
                };
                _this.service.toggleMallGoodsStatus(params).then(function (res) {
                    if (res.data.success) {
                        _this.getGoodList(_this.$refs.pagination.pager);
                        _this.$message.success(res.data.msg || "操作成功");
                    }
                    else {
                        _this.$message.error(res.data.msg || "操作失败");
                    }
                }, function (err) {
                    _this.$message.error(err.msg || "操作失败");
                });
            }
            window._czc.push(["_trackEvent", '货品列表', row.shopping_status == 1 ? '下架外销货品' : '上架外销货品', '确认']);
        }).catch(function () {
            window._czc.push(["_trackEvent", '货品列表', row.shopping_status == 1 ? '下架外销货品' : '上架外销货品', '取消']);
        });
    };
    List.prototype.toGoodDetail = function (row) {
        GlobalVue.$emit("addTab", {
            component: GoodDetail,
            title: '查看货品',
            showExist: true,
            name: 'good_detail_' + row.goods_id,
            cprops: {
                goodId: row.goods_id
            }
        });
    };
    List.prototype.moreSpec = function (row) {
        var instance = this.$dialog(CategoryDialog, {
            data: {
                goods_id: row.goods_id,
                goods_code: row.goods_code,
                inventory_unit_name: row.inventory_unit_name,
                Root_PageAuth$$: this.Root_PageAuth,
                openedCodeData$$: this.openedCodeData
            }
        }, {
            title: "多规格管理--" + row.goods_name + '-库存单位:' + row.inventory_unit_name,
            width: 800,
            height: 400
        }).instance;
    };
    List.prototype.search = function () {
        this.$refs.pagination.clear();
        this.getGoodList();
    };
    List.prototype.pageChange = function (pager) {
        this.getGoodList(pager);
    };
    List.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (!prop) {
            this.order = null;
        }
        else {
            this.order = [prop, order === 'ascending' ? 'asc' : 'desc'];
        }
        this.getGoodList(this.$refs.pagination.pager);
    };
    List.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    List.prototype.beforUpload = function (file) {
        this.uploadType = 'file';
        var name = file.name.split("."), fileType = name[name.length - 1];
        if (!(fileType && (fileType == "xlsx" || fileType == "xls" || fileType == "csv"))) {
            this.$message.error("文件只能是xlsx或xls");
            return false;
        }
        ;
        if (!this.loadingInstance)
            this.loadingInstance = Loading.service({ fullscreen: true });
    };
    List.prototype.uploadSuccess = function (response, file, fileList) {
        if (response.success) {
            this.responseSuccess = true;
            var data = response.data;
            this.importSuccessNum = data.success_num;
            this.importFailnum = data.error_num;
            var url = "supplierclientapi/suppliergoods/export_error?import_id=" + data.import_id;
            url = UrlHelper.addParam(url, 'token', this.user.token);
            this.failDownLoadUrl = url;
            this.getGoodList();
            window._czc.push(["_trackEvent", '货品列表', '导入货品']);
        }
        else {
            this.responseFail = true;
            this.errorMsg = response.msg || "网络异常，请重新导入";
            this.$message.error(response.msg);
        }
        this.uploadEnd(response);
    };
    List.prototype.uploadError = function (err, file, fileList) {
        this.responseFail = true;
        this.errorMsg = err.msg || err.message || "网络异常，请重新导入";
        this.uploadEnd();
    };
    List.prototype.uploadEnd = function (res) {
        if (!res.success && res.code && res.code == 9999) {
            this.responseFail = false;
            this.errorMsg = "";
            this.setUploadType("beford");
        }
        else {
            this.setUploadType("after");
        }
        this.loadingInstance.close();
    };
    List.prototype.uploadProgress = function (event, file, fileList) {
        this.setUploadType("importing");
    };
    List.prototype.setUploadType = function (type) {
        this.befordImport = type == 'beford';
        this.importting = type == 'importing';
        this.afterImport = type == 'after';
    };
    List.prototype.beforUploadForIcon = function (file) {
        this.uploadType = 'icon';
        var name = file.name.split("."), fileType = name[name.length - 1];
        if (!(fileType && (fileType == "zip"))) {
            this.$message.error("文件只能是zip");
            return false;
        }
        ;
        if (!this.loadingInstance)
            this.loadingInstance = Loading.service({ fullscreen: true });
    };
    List.prototype.uploadSuccessForIcon = function (response) {
        if (response.success) {
            this.imageResponseSuccess = true;
            var data = response.data;
            this.imageImportSuccessNum = data.success_num;
            this.imageImportFailNum = data.error_num;
            this.imageFailDownLoadUrl = data.error_image_url;
            this.imageImportFailData = data.error_msg;
            window._czc.push(["_trackEvent", '货品列表', '导入货品图片']);
        }
        else {
            this.imageResponseFail = true;
            this.$message.error(response.msg);
        }
        this.imageUploadEnd(response);
    };
    List.prototype.operateCommand = function (command) {
        switch (command) {
            case 1:
                this.transferGood();
                break;
            case 2:
                this.bindLicenses();
                break;
            case 3:
                this.setDefaultSupplier();
                break;
            case 4:
                this.imageUpload();
                break;
            case 5:
                this.publishToPurchaseSourceApp();
                break;
            case 6:
                this.multiGrunding(1);
                break;
            case 7:
                this.multiGrunding(0);
                break;
        }
    };
    List.prototype.exportGoodsCommand = function (command) {
        switch (command) {
            case 1:
                this.exportGoods(1);
                break;
            case 2:
                this.exportGoods(2);
                break;
        }
    };
    List.prototype.publishToPurchaseSourceApp = function () {
        var _this = this;
        if (!this.selectRows.length) {
            this.$message.error('请先选择货品！');
            return;
        }
        var goods_ids = this.selectRows.map(function (v) { return v.goods_id; });
        var params = {
            goods_id: String(goods_ids),
            is_upto_mall: 1
        };
        this.service.downupGood(params).then(function (res) {
            if (res.data.success) {
                _this.getGoodList(_this.$refs.pagination.pager);
                _this.$message.success(res.data.msg || "操作成功");
            }
            else {
                _this.$message.error(res.data.msg || "操作失败");
            }
        }, function (err) {
            _this.$message.error(err.msg || "操作失败");
        });
    };
    List.prototype.bindLicenses = function () {
        return __awaiter(this, void 0, void 0, function () {
            var goods_ids, loadingInstance, addedDatas, dialog;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.selectRows.length) {
                            this.$message.error('请先选择货品！');
                            return [2];
                        }
                        goods_ids = this.selectRows.map(function (v) { return v.goods_id; });
                        loadingInstance = Loading.service({ fullscreen: true });
                        return [4, this.getAlreadyBindLicenses(goods_ids)];
                    case 1:
                        addedDatas = _a.sent();
                        loadingInstance.close();
                        dialog = this.$dialog(AddLicenses, {
                            data: {
                                addedDatas: addedDatas
                            }
                        }, {
                            title: "绑定证照",
                            width: 950,
                            height: 500
                        });
                        dialog.instance.$on("save:ok", function (res) {
                            if (res.length == 0) {
                                _this.$message.warning('请至少选择一个证照');
                                return;
                            }
                            var document_ids = res.map(function (v) { return v.document_id; });
                            var params = {
                                goods_ids: goods_ids.join(','),
                                document_ids: document_ids.join(',')
                            };
                            _this.bindLicensesAjax(params, dialog);
                        });
                        return [2];
                }
            });
        });
    };
    List.prototype.bindLicensesAjax = function (params, dialog) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.goodBindLicenses(params).then(function (res) {
            loadingInstance.close();
            if (res.data.success) {
                if (res.data.code == 46) {
                    var instance = _this.$dialog(ArtMsglist, {
                        data: {
                            msgData: res.data.data,
                        }
                    }, {
                        title: "提示",
                        width: 450,
                        height: 350
                    }).instance;
                    instance.$on("artMsglist:ok", function (data) {
                        var confirm = res.data.data[0].confirm;
                        _this.bindLicensesAjax(__assign({}, params, { confirm: confirm }), dialog);
                    });
                }
                else {
                    _this.$message.success('绑定证照成功!');
                    dialog.instance.close();
                    _this.getGoodList(_this.$refs.pagination.pager);
                }
            }
            else {
                loadingInstance.close();
                _this.$message.error(res.data.msg);
            }
            window._czc.push(["_trackEvent", '货品列表', '绑定证照']);
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    List.prototype.getAlreadyBindLicenses = function (goods_ids) {
        return __awaiter(this, void 0, void 0, function () {
            var result, params;
            var _this = this;
            return __generator(this, function (_a) {
                result = [];
                params = {};
                Object.assign(params, {
                    goods_ids: goods_ids.join(',')
                });
                return [2, this.service.getGoodAlreadyBindLicensesIds(params).then(function (res) {
                        var document_ids = [];
                        if (res.data.success) {
                            document_ids = res.data.data.document_ids || [];
                        }
                        else {
                            _this.$message.error(res.data.msg);
                        }
                        return document_ids;
                    }).then(function (document_ids) {
                        if (document_ids.length > 0) {
                            var params_2 = {
                                page: 1,
                                start: 0,
                                limit: 2000
                            };
                            Object.assign(params_2, {
                                in_document_ids: (document_ids || []).join(',')
                            });
                            return _this.licenseService.getLicenseList(params_2).then(function (res) {
                                if (res.data.success) {
                                    result = res.data.data;
                                }
                                return result;
                            });
                        }
                        else {
                            return [];
                        }
                    }).catch(function () {
                        return result;
                    })];
            });
        });
    };
    List.prototype.seeBindLicenses = function (row) {
        GlobalVue.$emit('addTab', {
            component: SeeBindLicenses,
            opener: this,
            title: '查看绑定证照',
            showExist: true,
            name: 'goods-see-bind-license' + row.goods_id,
            cprops: {
                goods_id: row.goods_id,
                goods_name: row.goods_name,
                goods_code: row.goods_code
            }
        });
    };
    List.prototype.imageUpload = function () {
        this.dialogImageVisible = true;
        this.setImageUploadType('image_before');
    };
    List.prototype.imageUploadProgress = function (event, file, fileList) {
        this.setUploadType("image_importing");
    };
    List.prototype.imageUploadEnd = function (res) {
        if (!res.success && res.code && res.code == 9999) {
            this.responseFail = false;
            this.errorMsg = "";
            this.setImageUploadType("image_before");
        }
        else {
            this.setImageUploadType("image_after");
        }
        this.loadingInstance.close();
    };
    List.prototype.setImageUploadType = function (type) {
        console.log(type);
        this.imageBeforeImport = type == 'image_before';
        this.imageImporting = type == 'image_importing';
        this.imageAfterImport = type == 'image_after';
    };
    List = __decorate([
        Component({
            components: {
                'pagination': Pagination
            },
            computed: __assign({}, mapGetters({
                "user": "user",
                openedCodeData: 'openedCodeData'
            })),
            methods: __assign({}, mapActions(["getAuth"]))
        })
    ], List);
    return List;
}(Vue));
export default List;
